import React, { FC, useState } from 'react'

import { Colors } from '../constants/Theme'
import { LoadingIconComponent } from './loadingIcon/LoadingIconComponent'
import { ThreeDots } from 'react-loader-spinner'

type Props = {
  icon: string
  title: string
}
export const PeopleWeLoveRowComponent: FC<Props> = ({ icon, title }: Props) => {
  const [isDownloading, setIsDownLoading] = useState(false)
  const onClick = () => {
    if (isDownloading) return
    console.log('onClick')
    // setIsDownLoading(true)
  }
  const renderInside = () => {
    if (isDownloading) {
      return (
        <div className="customer-row">
          <div className="c_img" style={{ flexShrink: 1, minWidth: 50 }}>
            <ThreeDots
              height="30"
              width="50"
              radius="9"
              color={Colors.loader}
              ariaLabel="three-dots-loading"
              wrapperStyle={{ width: '100%', display: 'flex', flexDirection: 'column' }}
              wrapperClass=""
              visible
            />
          </div>
          <div className="c_info" style={{ flex: 1, textAlign: 'left' }}>
            {`Downloading ${title}`}
          </div>
        </div>
      )
    }
    return (
      <div className="customer-row">
        <div className="c_img" style={{ backgroundImage: `url(${icon})`, flexShrink: 1 }} />
        <div className="c_info" style={{ flex: 1, textAlign: 'left' }}>
          {title}
        </div>
        <div className="c_info" style={{ flexShrink: 1 }}>
          DOWNLOAD
        </div>
      </div>
    )
  }
  return (
    <div className="stage-row mb-3" onClick={onClick}>
      {renderInside()}
    </div>
  )
}
